import { render, staticRenderFns } from "./AdvertisingView.vue?vue&type=template&id=02d68045"
import script from "./AdvertisingView.vue?vue&type=script&lang=js"
export * from "./AdvertisingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports